import React from "react";

const Footer = (props) => {
  return (
    <footer className="footer"
    style={{
      background:"#fff",
      borderTop:"1px solid #f6f7fb",
      padding:"25px"
    }}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-10 footer-copyright">
            <p className="mb-0">
              {/* Copyright 2020 © Admin Panel All rights reserved.  */}© 2020
              Arab Tech Store. All Rights Reserved | Developed & Designed By{" "}
              <a href="http://gaviralgamtec.com/" target="_blank">
                Gaviral Gamtec Private Limited
              </a>
            </p>
          </div>
          <div className="col-md-2">
            {/* <p className="pull-right mb-0">
              
              <i className="fa fa-heart"></i>
            </p> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
